import { HttpClient } from '@angular/common/http';
import { AppConfigSettings } from '@arc/arc-shared-frontend';
import {
  PaymentAuthorizationVerbiageGuestCheckoutService,
  PaymentAuthorizationVerbiagePaymentLinksService,
  PaymentAuthorizationVerbiagePlatformService,
  PaymentAuthorizationVerbiageService,
} from '../services';
import { Injectable } from '@angular/core';

export const paymentAuthorizationVerbiageServiceFactory = (
  httpClient: HttpClient,
  appConfig: AppConfigSettings,
) => {
  let service: PaymentAuthorizationVerbiageService;

  if (appConfig.getconfig('usePaymentLinkEndpoints') === 'true') {
    service = new PaymentAuthorizationVerbiagePaymentLinksService(
      httpClient,
      appConfig,
    );
  } else if (appConfig.getconfig('useHostedPaymentsPageEndpoints') === 'true') {
    service = new PaymentAuthorizationVerbiageGuestCheckoutService(
      httpClient,
      appConfig,
    );
  } else {
    service = new PaymentAuthorizationVerbiagePlatformService(
      httpClient,
      appConfig,
    );
  }

  return service;
};

@Injectable({
  providedIn: 'root',
})
export class PaymentAuthorizationVerbiageServiceFactory {
  constructor(
    private httpClient: HttpClient,
    private appConfig: AppConfigSettings,
  ) {}

  create() {
    return paymentAuthorizationVerbiageServiceFactory(
      this.httpClient,
      this.appConfig,
    );
  }
}
